import { theme_light } from "./common_light";

export const theme_tateshina_light = {
  ...theme_light,
  primary: {
    theme_lv1: "#00A39A", // テーマカラー1、ボタン、テキスト
    theme_lv2: "#99CCAA", // テーマカラー2、アクティブ、ボリューム閾値未満
    theme_lv3: "#E5F6F5", // テーマカラー3、インアクティブ
    theme_lv4: "#4D4D4D", // テーマカラー4、読み上げテキスト
    gray_c: "#CCCCCC", // グレー、ボタンの無効化
    emotion_joy: "#f5ce00",
    emotion_anger: "#d85336",
    emotion_sadness: "#2581c5",
    emotion_calm: "#6eb759",
    emotion_excitement: "#ED6D00", // 興奮度
    accent: "#F34824", // アクセントカラー（ボリュームゲージの最大、ボリューム閾値）
    bg_lv1: "#FFFFFF", // 背景色1
  },
};
